function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0 26C0 11.6406 11.6406 0 26 0C40.3594 0 52 11.6406 52 26C52 40.3594 40.3594 52 26 52C11.6406 52 0 40.3594 0 26Z",
  fill: "#CE1312"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M39.5321 20.7666C39.5321 20.7666 39.2612 18.8138 38.4313 17.9538C37.3781 16.8246 36.1977 16.8193 35.6568 16.7537C31.7814 16.4668 25.9684 16.4668 25.9684 16.4668H25.9563C25.9563 16.4668 20.1433 16.4668 16.268 16.7537C15.7262 16.8193 14.5467 16.8246 13.4926 17.9538C12.6627 18.8138 12.3927 20.7666 12.3927 20.7666C12.3927 20.7666 12.1157 23.0605 12.1157 25.3534V27.5038C12.1157 29.7976 12.3927 32.0906 12.3927 32.0906C12.3927 32.0906 12.6627 34.0434 13.4926 34.9034C14.5467 36.0326 15.9305 35.9972 16.5467 36.1149C18.7621 36.3328 25.9624 36.4001 25.9624 36.4001C25.9624 36.4001 31.7814 36.3913 35.6568 36.1043C36.1977 36.0379 37.3781 36.0326 38.4313 34.9034C39.2612 34.0434 39.5321 32.0906 39.5321 32.0906C39.5321 32.0906 39.809 29.7976 39.809 27.5038V25.3534C39.809 23.0605 39.5321 20.7666 39.5321 20.7666V20.7666Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M23.1034 30.1094L23.1025 22.1465L30.5849 26.1417L23.1034 30.1094Z",
  fill: "#CE1312"
});

function SvgYoutube(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/Youtube.2349b447.svg";
export { ForwardRef as ReactComponent };